import {call} from "redux-saga/effects";
import axios from "axios";
import {CONFIDENTIALITY_ENDPOINT, TERMS_ENDPOINT, CONTACT_PAGE_ENDPOINT} from "../config/apiEndpoints";
import { getDefaultHeaders as headers, getTokenHeaders as tokenHeader } from "../helpers/api.helper";

export function* getTermsPage() {
    return yield call(axios.get, TERMS_ENDPOINT, {}, headers() );
}

export function* getConfidentialityPage() {
    return yield call(axios.get, CONFIDENTIALITY_ENDPOINT, {}, headers() );
}

export function* contactPage(payload) {
    const header = tokenHeader();
    return yield call(axios.post, CONTACT_PAGE_ENDPOINT, payload, header);
}


// WEBPACK FOOTER //
// ./src/SHARED/api/pages.api.js